export default "__VITE_ASSET__CpgSmKUs__"